export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_37-c6ce0d7bb9c6ad449fce0117e5a2b72c.jpg";